export const translations = {
  'fr-FR': {
    translation: {
      showToday: `Afficher aujourd'hui`,
      outOfRange: 'Hors plage',
      selectUpToDays: 'Sélectionnez la date dans les {maxDays} jours',
      From: 'De',
      FromToDateRangeError: `La Date de fin ne doit pas être antérieure à la Date de début`,
      to: 'Pour',
      dateFrom: 'Date de début',
      loadingError: 'Erreur de chargement',
      contactAdmin:
        'Actualisez la page pour charger les données. Contactez votre administrateur si le problème persiste.',
      searchFor: 'Rechercher',
      nodes: 'Nœuds',
      cancel: 'Annuler',
      back: 'Précédent',
      saveAndContinue: 'Sauvegarder et continuer',
      yes: 'Oui',
      no: 'Non',
      selectDateRange: 'Select the date range between {days} days',
      Today: 'Today',
      Yesterday: 'Yesterday',
      LastWeek: 'Last Week',
      ThisMonth: 'This Month',
      LastMonth: 'Last Month',
      Last3Months: 'Last 3 Months',
      Last6Months: 'Last 6 Months',
      YearToDate: 'Year To Date',
      LastYear: 'Last Year',
      datePickerErrorMsg: 'Please select the dates within {days} months range.',
      datePickerGreaterErrorMessage: 'From Date cannot be greater than To Date',
      Duration: 'Duration',
      To: 'To',
      apply: 'Apply'
    }
  }
};
